export enum CenteredSlideCustomComponent {
  Equation = 'equation',
  TilesGrid = 'tilesGrid',
  DefinitionCard = 'definitionCard',
  InfoPair = 'infoPair',
  TextGrid = 'textGrid',
  BoxWithImages = 'boxWithImages'
}
